import { FC } from 'react';
import BaseTemplate from '../BaseTemplate';
import { Container } from 'react-bootstrap';
import { StoryResponseDto } from '../../../store/landscapeAPI/story/dto/response/story-response.dto';
import { LandscapeStoryOrganism } from '../../organisms';
import LandscapeStoryBaseAddTemplate from '../../../templates/LandscapeStoryBaseAddTemplate';
import { ImageMeta } from '../../../store/mediaAPI/media/dto/request/media-save-request';

export interface LandscapeAddStoryTemplateProps {
  story: StoryResponseDto;
  handleOnChange: (story: StoryResponseDto) => void;
  handleImageOnChange: (imageMeta: ImageMeta) => void;
  callbackFn: (story: StoryResponseDto) => void;
}

const LandscapeAddStoryTemplate: FC<LandscapeAddStoryTemplateProps> = ({
  story,
  handleOnChange,
  handleImageOnChange,
  callbackFn,
}) => {
  return (
    <BaseTemplate>
      <Container>
        <LandscapeStoryBaseAddTemplate>
          <LandscapeStoryOrganism
            story={story}
            handleOnChange={handleOnChange}
            handleImageOnChange={handleImageOnChange}
            callbackFn={callbackFn}
          />
        </LandscapeStoryBaseAddTemplate>
      </Container>
    </BaseTemplate>
  );
};

export default LandscapeAddStoryTemplate;
